<template>
  <div class="date-picker" @click="open = true">
    <m-button :dark="dark" class="date-button">
      <i-calendar class="date-button-icon" :title="null" />
      <div>{{ (!$i18n.locale || !date ? [] : [ date, 'YYYY-MM-DD' ]) | moment('DD.MM.YYYY') }}</div>
    </m-button>
    <drop-board position="bottom" v-show="open">
      <datepicker
        :language="locales[$i18n.locale]"
        :value="date"
        :inline="true"
        @selected="select" />
    </drop-board>
  </div>
</template>

<script>
import ICalendar from 'vue-material-design-icons/Calendar'
import Datepicker from 'vuejs-datepicker'
import { en, ru } from 'vuejs-datepicker/dist/locale'
import DropBoard from '@/components/DropBoard'
import MButton from '@/components/buttons/MButton'

export default {
  components: {
    ICalendar,
    Datepicker,
    DropBoard,
    MButton
  },
  props: {
    date: String,
    dark: Boolean
  },
  data () {
    return {
      open: false,
      locales: { en, ru }
    }
  },
  mounted () {
    document.addEventListener('click', this.handleDocumentClick.bind(this))
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleDocumentClick.bind(this))
  },
  methods: {
    handleDocumentClick (event) {
      let target = event.target || event.srcElement
      if (!target.closest('.date-picker')) {
        this.open = false
      }
    },
    close () {
      this.open = false
    },
    select (date) {
      setTimeout(this.close, 10)
      this.$emit('change', date.toISOString().split('T')[0])
    }
  }
}
</script>

<style scoped>
.date-picker { position: relative; }

.date-button { align-items: center; cursor: pointer; display: flex; height: 40px; line-height: 40px; padding: 0 10px; }
.date-button-icon { font-size: 18px; margin-right: 7px; }

.drop-board { left: 50%; margin-left: -115px; padding: 5px 4px 5px 5px; width: 230px; }
.drop-board:before { left: 50%; }
</style>

<style>
.date-picker .vdp-datepicker__calendar { color: #2c3e50; width: 221px; }
.date-picker .vdp-datepicker__calendar header .prev,
.date-picker .vdp-datepicker__calendar header .next,
.date-picker .vdp-datepicker__calendar header .up { -webkit-transition: all .3s; -moz-transition: all .3s; -o-transition: all .3s; transition: all .3s; }
.date-picker .vdp-datepicker__calendar header .prev::after { border-right: 10px solid #342d6e !important; }
.date-picker .vdp-datepicker__calendar header .next::after { border-left: 10px solid #342d6e !important; }
.date-picker .vdp-datepicker__calendar header .prev:not(.disabled):hover,
.date-picker .vdp-datepicker__calendar header .next:not(.disabled):hover,
.date-picker .vdp-datepicker__calendar header .up:not(.disabled):hover { background: rgba(0, 0, 0, .1); }
.date-picker .vdp-datepicker__calendar header .prev:after { margin-left: -4px; }
.date-picker .vdp-datepicker__calendar header .next:after { margin-left: 4px; }
.date-picker .vdp-datepicker__calendar .cell { border-radius: 2px; height: 30px; line-height: 30px; -webkit-transition: all .3s; -moz-transition: all .3s; -o-transition: all .3s; transition: all .3s; background: none !important; }
.date-picker .vdp-datepicker__calendar .cell.selected { outline: none !important; background: #8ce95d !important; }
.date-picker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
.date-picker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
.date-picker .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover { border: 1px solid #342d6e; }
.date-picker .vdp-datepicker__calendar .cell.selected,
.date-picker .vdp-datepicker__calendar .cell.selected:hover { background: #342d6e; }
</style>



// WEBPACK FOOTER //
// src/components/buttons/DateButton.vue